var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisualPermiss === '省')?_c('svg-icon',{staticClass:"screen_icon",attrs:{"icon-class":"visualScreen"},on:{"click":_vm.visualScreenRoute}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }